import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69b5874e6b5d6f001498a3d0_1786390235552_ea3726b8/agroguard/src/app/forgot-password/page.tsx");
